module.exports = __webpack_public_path__ + "static/media/banner-all-product.012edd63.jpg";